"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _axios = _interopRequireDefault(require("axios"));
var _dateFns = require("date-fns");
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _reactScrollIntoView = _interopRequireDefault(require("react-scroll-into-view"));
require("../css/rates.css");
var _rates2 = _interopRequireDefault(require("../components/rates"));
var _ThemeConfig = _interopRequireDefault(require("./ThemeConfig"));
var _applynow = require("applynow");
var _usersession = require("usersession");
var _PriceForState = _interopRequireDefault(require("./PriceForState"));
var _actions = require("../store/actions");
var _reactRedux = require("react-redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

/*
  6/13/2020 - Suhas

  This page shows the Rates section in the Landing page.

    The Rates section is separated in 3 parts as follows:
    1] RATES
        The Rates are fetched from the public URL of Pricing Engine
        The URL is fetched from "COMMON" set.

        The received response is read and shown in a format for:
        1. Conventional (15Yr Fixed and 30Yr Fixed)
        2. FHA (15Yr Fixed and 30Yr Fixed)
        3. VA (15Yr Fixed and 30Yr Fixed) - While fetching from the response, it will be USDA

        The APR is calculated based on the JSON file that we are using.

    2] Customize Quote
        This is a button below the Rates section.
        It will allows user to Cutomize the Rates shown in section 1, based on the user selection.

        On submission of the user selection, it will show the Rates table as in section 1 and replece section 1 rates.

        When the Customize Quote is selected, button will be hidden. Then Today's Rates button will be shown
        If clicked on Today's Rates and then clicked back on Customize Quote, then the slider should start from the beginning

    3] Apply Now
        This will redict to the ApplyNow with its lead id as c=lrtv.

        If the user has customized a quote, it add the customized options with ApplyNow link for POST.
        This will pre-select/prefill the ApplyNow when user is redirected.

*/

function Rates(props) {
  const dispatch = (0, _reactRedux.useDispatch)();
  const userSession = new _usersession.UserSession();
  const themeConfig = new _ThemeConfig.default(props);

  // console.log(themeConfig.requestRates);
  let themeLeadSource = themeConfig.requestRates.purchase.leadSource;
  let themePurchaseLoanPurpose = themeConfig.requestRates.purchase.loanPurpose;
  let themeRefinanceLoanPurpose = themeConfig.requestRates.cashoutrefinance ? themeConfig.requestRates.cashoutrefinance.loanPurpose : themeConfig.requestRates.refinance.loanPurpose;
  // HomeEquity added by Ankita Porwal on 01 /05 / 2024 - JIRA Task - WEB - 566
  let themeHomeEquityLoanPurpose = themeConfig.requestRates.homeEquity.loanPurpose; //Ankita Porwal Added on 01/05/2024

  const domain = themeConfig.domain;
  const defaultProduct = props.defaultProduct || "purchase";
  const [noCCProgram, setNoCCProgram] = (0, _react.useState)(false);
  const [show, setShow] = (0, _react.useState)(true); //  -----------> Currently hard coded to show the Rates section by default
  const [stateName, setStateName] = (0, _react.useState)("");
  const [productLoading, setProductLoading] = (0, _react.useState)(false);
  const [showPurchaseRates, setPurchaseRates] = (0, _react.useState)(true);
  const [showRefinanceRates, setRefinanceRates] = (0, _react.useState)(false);
  const [showHomeEquityRates, setHomeEquityRates] = (0, _react.useState)(false); //Ankita Porwal Added on 01/05/2024
  const [showPurchaseCvnRates, setPurchaseCvnRates] = (0, _react.useState)(true);
  const [showPurchaseFHARates, setPurchaseFHARates] = (0, _react.useState)(false);
  const [showPurchaseVARates, setPurchaseVARates] = (0, _react.useState)(false);
  const [showPurchaseUsdaRates, setPurchaseUsdaRates] = (0, _react.useState)(false);
  const [showRefinanceCvnRates, setRefinanceCvnRates] = (0, _react.useState)(true);
  const [showRefinanceFHARates, setRefinanceFHARates] = (0, _react.useState)(false);
  const [showRefinanceVARates, setRefinanceVARates] = (0, _react.useState)(false);
  const [showRefinanceUsdaRates, setRefinanceUsdaRates] = (0, _react.useState)(false);
  const [showHomeEquity2ndTDRates, setHomeEquity2ndTDRates] = (0, _react.useState)(true);
  const [purchaseTab, setPurchaseTab] = (0, _react.useState)(false);
  const [refinanceTab, setRefinanceTab] = (0, _react.useState)(false);
  const [homeEquityTab, setHomeEquityTab] = (0, _react.useState)(false); //Ankita Porwal Added on 01/05/2024
  const [showHomeEquityTab, setShowHomeEquityTab] = (0, _react.useState)(false); //Akhilesh Rajput Added on 01/05/2024
  const [purchaseConvTab, setPurchaseConvTab] = (0, _react.useState)(false);
  const [purchaseFhaTab, setPurchaseFhaTab] = (0, _react.useState)(false);
  const [purchaseVaTab, setPurchaseVaTab] = (0, _react.useState)(false);
  const [purchaseUsdaTab, setPurchaseUsdaTab] = (0, _react.useState)(false);
  const [refinanceConvTab, setRefinanceConvTab] = (0, _react.useState)(false);
  const [refinanceFhaTab, setRefinanceFhaTab] = (0, _react.useState)(false);
  const [refinanceVaTab, setRefinanceVaTab] = (0, _react.useState)(false);
  const [refinanceUsdaTab, setRefinanceUsdaTab] = (0, _react.useState)(false);

  /* States to set the received data from Pricing */
  const [defaultCreditScore, setDefaultCreditScore] = (0, _react.useState)(themeConfig.requestRates.purchase.creditScore);
  const [branchLoanAmount, setBranchLoanAmount] = (0, _react.useState)(themeConfig.requestRates.purchase.loanAmount);
  const [branchPropertyValue, setBranchPropertyValue] = (0, _react.useState)(themeConfig.requestRates.purchase.propertyValue);
  const [defaultLoanProgramTab, setDefaultLoanProgramTab] = (0, _react.useState)(defaultProduct);
  const [selectTab, setSelectTab] = (0, _react.useState)(null);
  const [defaultLowRateTab, setDefaultLowRateTab] = (0, _react.useState)(null);
  const [defaultPurchaseTab, setDefaultPurchaseTab] = (0, _react.useState)(null);
  const [defaultRefinanceTab, setDefaultRefinanceTab] = (0, _react.useState)(null);
  const [loadingRates, setLoadingRates] = (0, _react.useState)(true);
  const [purchaseConvRateAvailable, setPurchaseConvRateAvailable] = (0, _react.useState)(false);
  const [purchaseFhaRateAvailable, setPurchaseFhaRateAvailable] = (0, _react.useState)(false);
  const [refinanceConvRateAvailable, setRefinanceConvRateAvailable] = (0, _react.useState)(false);
  const [refinanceFhaRateAvailable, setRefinanceFhaRateAvailable] = (0, _react.useState)(false);
  const [purchaseConv15A, setPurchaseConv15A] = (0, _react.useState)("");
  const [purchaseConv30A, setPurchaseConv30A] = (0, _react.useState)("");
  const [purchaseFha15A, setPurchaseFha15A] = (0, _react.useState)("");
  const [purchaseFha30A, setPurchaseFha30A] = (0, _react.useState)("");
  const [purchaseVa15A, setPurchaseVa15A] = (0, _react.useState)("");
  const [purchaseVa30A, setPurchaseVa30A] = (0, _react.useState)("");
  const [purchaseUsda15A, setPurchaseUsda15A] = (0, _react.useState)("");
  const [purchaseUsda30A, setPurchaseUsda30A] = (0, _react.useState)("");
  const [refinanceConv15A, setRefinanceConv15A] = (0, _react.useState)("");
  const [refinanceConv30A, setRefinanceConv30A] = (0, _react.useState)("");
  const [refinanceFha15A, setRefinanceFha15A] = (0, _react.useState)("");
  const [refinanceFha30A, setRefinanceFha30A] = (0, _react.useState)("");
  const [refinanceVa15A, setRefinanceVa15A] = (0, _react.useState)("");
  const [refinanceVa30A, setRefinanceVa30A] = (0, _react.useState)("");
  const [refinanceUsda15A, setRefinanceUsda15A] = (0, _react.useState)("");
  const [refinanceUsda30A, setRefinanceUsda30A] = (0, _react.useState)("");
  const [homeEquity2NDTD30A, setHomeEquity2NDTD30A] = (0, _react.useState)("");
  const [homeEquity2NDTD20A, setHomeEquity2NDTD20A] = (0, _react.useState)("");
  const [homeEquity2NDTD15A, setHomeEquity2NDTD15A] = (0, _react.useState)("");
  const [homeEquity2NDTD10A, setHomeEquity2NDTD10A] = (0, _react.useState)("");
  const [purchaseFhaLimit, setPurchaseFhaLimit] = (0, _react.useState)("");
  const [purchaseConvLimit, setPurchaseConvLimit] = (0, _react.useState)("");
  const [purchaseVaLimit, setPurchaseVaLimit] = (0, _react.useState)("");
  const [purchaseUsdaLimit, setPurchaseUsdaLimit] = (0, _react.useState)("");
  const [refinanceFhaLimit, setRefinanceFhaLimit] = (0, _react.useState)("");
  const [refinanceConvLimit, setRefinanceConvLimit] = (0, _react.useState)("");
  const [refinanceVaLimit, setRefinanceVaLimit] = (0, _react.useState)("");
  const [refinanceUsdaLimit, setRefinanceUsdaLimit] = (0, _react.useState)("");
  const [productCreationTime, setProductCreationTime] = (0, _react.useState)("");

  /* End of States to set the received data from Pricing */

  const [customButton, setCustomButton] = (0, _react.useState)(true); //  State to toggle the view of Customize Quote button
  const [showDescription, setShowDescription] = (0, _react.useState)(true);
  const [customRateQuote, setCustomRateQuote] = (0, _react.useState)(false); //  State for Customize Quote button to toggle Rates

  const handleLoanPurposeTabs = key => {
    localStorage.setItem("loanPurpCheckedTab", key);
    if (key === "purchase") {
      setPurchaseRates(true);
      setRefinanceRates(false);
      setHomeEquityRates(false);
      saveSelectedLoanPurposeDetails("PURCHASE");
    } else if (key === "homeEquity") {
      //Ankita Porwal Added on 01/05/2024
      setPurchaseRates(false);
      setRefinanceRates(false);
      setHomeEquityRates(true);
      saveSelectedLoanPurposeDetails("HOME EQUITY CLOSED END SCENARIO");
    } else if (key === "refinance") {
      setPurchaseRates(false);
      setRefinanceRates(true);
      setHomeEquityRates(false);
      saveSelectedLoanPurposeDetails("FULL DOCS REFI");
    } else if (key === "cashoutrefinance") {
      setPurchaseRates(false);
      setRefinanceRates(true);
      setHomeEquityRates(false);
      saveSelectedLoanPurposeDetails("CASH OUT REFI");
    }
  };
  const handlePurchaseProdTabs = key => {
    localStorage.setItem("checkedTab", key); // REACT-69
    if (key === "conventional") {
      setPurchaseCvnRates(true);
      setPurchaseFHARates(false);
      setPurchaseVARates(false);
      setPurchaseUsdaRates(false);
      savePurchaseCVNDetails();
    } else if (key === "fha") {
      setPurchaseCvnRates(false);
      setPurchaseFHARates(true);
      setPurchaseVARates(false);
      setPurchaseUsdaRates(false);
      savePurchaseFHADetails();
    } else if (key === "va") {
      setPurchaseCvnRates(false);
      setPurchaseFHARates(false);
      setPurchaseVARates(true);
      setPurchaseUsdaRates(false);
      savePurchaseVADetails();
    } else if (key === "usda") {
      setPurchaseCvnRates(false);
      setPurchaseFHARates(false);
      setPurchaseVARates(false);
      setPurchaseUsdaRates(true);
      savePurchaseUsdaDetails();
    }
  };

  //Ankita Porwal Added on 02/26/2024 - WEB-566
  //Function to set the HomeEquity 2nd TDRates
  const handleHomeEquityProdTabs = () => {
    setHomeEquity2ndTDRates(true);
    saveHomeEquity2ndTdDetails();
  };
  const handleRefinanceProdTabs = key => {
    localStorage.setItem("checkedTab", key); // REACT-69
    if (key === "conventional") {
      setRefinanceCvnRates(true);
      setRefinanceFHARates(false);
      setRefinanceVARates(false);
      setRefinanceUsdaRates(false);
      saveRefinanceCVNDetails();
    } else if (key === "fha") {
      setRefinanceCvnRates(false);
      setRefinanceFHARates(true);
      setRefinanceVARates(false);
      setRefinanceUsdaRates(false);
      saveRefinanceFHADetails();
    } else if (key === "va") {
      setRefinanceCvnRates(false);
      setRefinanceFHARates(false);
      setRefinanceVARates(true);
      setRefinanceUsdaRates(false);
      saveRefinanceVADetails();
    } else if (key === "usda") {
      setRefinanceCvnRates(false);
      setRefinanceFHARates(false);
      setRefinanceVARates(false);
      setRefinanceUsdaRates(true);
      saveRefinanceUsdaDetails();
    }
  };
  function savePurchaseUsdaDetails() {
    if (purchaseUsda15A.match === true) {
      saveSelectedProductDetails(purchaseUsda15A);
    } else if (purchaseUsda30A.match === true) {
      saveSelectedProductDetails(purchaseUsda30A);
    }
  }
  function savePurchaseVADetails() {
    if (purchaseVa15A.match === true) {
      saveSelectedProductDetails(purchaseVa15A);
    } else if (purchaseVa30A.match === true) {
      saveSelectedProductDetails(purchaseVa30A);
    }
  }
  function savePurchaseFHADetails() {
    if (purchaseFha15A.match === true) {
      saveSelectedProductDetails(purchaseFha15A);
    } else if (purchaseFha30A.match === true) {
      saveSelectedProductDetails(purchaseFha30A);
    }
  }
  function savePurchaseCVNDetails() {
    if (purchaseConv15A.match === true) {
      saveSelectedProductDetails(purchaseConv15A);
    } else if (purchaseConv30A.match === true) {
      saveSelectedProductDetails(purchaseConv30A);
    }
  }
  function saveRefinanceUsdaDetails() {
    if (refinanceUsda15A.match === true) {
      saveSelectedProductDetails(refinanceUsda15A);
    } else if (refinanceUsda30A.match === true) {
      saveSelectedProductDetails(refinanceUsda30A);
    }
  }
  function saveRefinanceVADetails() {
    if (refinanceVa15A.match === true) {
      saveSelectedProductDetails(refinanceVa15A);
    } else if (refinanceVa30A.match === true) {
      saveSelectedProductDetails(refinanceVa30A);
    }
  }
  function saveRefinanceFHADetails() {
    if (refinanceFha15A.match === true) {
      saveSelectedProductDetails(refinanceFha15A);
    } else if (refinanceFha30A.match === true) {
      saveSelectedProductDetails(refinanceFha30A);
    }
  }
  function saveRefinanceCVNDetails() {
    if (refinanceConv15A.match === true) {
      saveSelectedProductDetails(refinanceConv15A);
    } else if (refinanceConv30A.match === true) {
      saveSelectedProductDetails(refinanceConv30A);
    }
  }

  //Ankita Porwal Added on 02/26/2024 - WEB-566
  //Function to set the HomeEquity 2nd TDRates for the 15 years and 30 years
  function saveHomeEquity2ndTdDetails() {
    if (homeEquity2NDTD15A.match === true) {
      saveSelectedProductDetails(homeEquity2NDTD15A);
    } else if (homeEquity2NDTD30A.match === true) {
      saveSelectedProductDetails(homeEquity2NDTD30A);
    }
  }
  function saveSelectedLoanPurposeDetails(selectedLoanPurpose) {
    userSession.setLoanPurpose(selectedLoanPurpose);
  }
  function saveSelectedProductDetails(selectedProduct) {
    userSession.getSelectedProduct().setLoanType(selectedProduct.loanType);
  }
  const saveInitialRequestData = requestedJson => {
    const reqJSONData = showPurchaseRates ? requestedJson.purchase : requestedJson.cashoutrefinance ? requestedJson.cashoutrefinance : requestedJson.refinance;
    switch (reqJSONData.loanPurpose) {
      case 0:
        userSession.setLoanPurpose("PURCHASE");
        break;
      case 1:
        userSession.setLoanPurpose("FULL DOCS REFI");
        break;
      case 2:
        userSession.setLoanPurpose("CASH OUT REFI");
        break;
      //no default
    }
    userSession.setLeadSource(reqJSONData.leadSource);
    userSession.setPropertyState(reqJSONData.propertyState);
    userSession.setPropertyZipCode(reqJSONData.propertyZipCode);
    userSession.setBranchCode(reqJSONData.branchCode);
    userSession.setPromoCode(reqJSONData.promoCode);
    userSession.setPropertyType(reqJSONData.propertyTypeKeyword);
  };
  async function locationError(error) {
    // Get the default price scenario
    await getPrice(themeConfig.requestRates.purchase.leadSource);
  }

  /** REACT-69: For Autism Heroes, this condition should work */
  const isAutismHeroes = props.promoCode && props.promoCode === "ATH" ? true : false;

  /** No scrolling for FLW in customize quote */
  const isFLW = themeLeadSource === "NET049" && themeConfig.requestRates.promoCode === "FLW";
  localStorage.setItem("doNotScroll", isAutismHeroes || isFLW);

  // get default config data
  const getDefaultConfig = async leadSource => {
    let theme_id = "frontlinewarriors";
    if (leadSource === "NET007") theme_id = "lowrates-com-pricing-v2";
    // if (leadSource === "TEXAS-TV") theme_id = "lowrates-tv";
    // if (leadSource === "CREDKARMA") theme_id = "creditkarma";
    // if (leadSource === "NET001") theme_id = "swmc";
    // if (leadSource === "INHNPORT-017") theme_id = "cashout";
    // if (leadSource === "NET021") theme_id = "getvahomeloan";
    // if (isAutismHeroes) theme_id = "autismHeroes";

    // Get the config data
    const configData = await (0, _axios.default)("".concat(process.env.REACT_APP_RATE_PRODUCT, "/").concat(theme_id, "-config.json"));

    // if (leadSource === "INHNPORT-017") {
    //   const tempConfigData = configData.data[0].purchase;
    //   setDefaultCreditScore(tempConfigData.VA_30_YR_FIXED.fico);
    //   setBranchLoanAmount(tempConfigData.VA_30_YR_FIXED.loanAmount);
    //   setBranchPropertyValue(tempConfigData.VA_30_YR_FIXED.propertyValue);
    //   saveInitialRequestData(tempConfigData.VA_30_YR_FIXED);
    // } else {
    const themeConfigData = configData.data[0].purchase;
    if (themeConfigData) {
      setDefaultCreditScore(themeConfigData.creditScore);
      setBranchLoanAmount(themeConfigData.loanAmount);
      setBranchPropertyValue(themeConfigData.propertyValue);
      saveInitialRequestData(configData.data[0]);
    }
    // }
  };

  /**
   * @description Get the static data from s3.
   * @param leadSource leadsource of the website
   * @param userStateCode state code of the user
   */
  const getPrice = async (leadSource, userStateCode) => {
    let theme_id = "frontlinewarriors";
    if (leadSource === "NET007") theme_id = "lowrates-com-pricing-v2";
    // if (leadSource === "TEXAS-TV") theme_id = "lowrates-tv";
    // if (leadSource === "CREDKARMA") theme_id = "creditkarma";
    // if (leadSource === "NET001") theme_id = "swmc";
    // if (leadSource === "INHNPORT-017") theme_id = "cashout";
    // if (leadSource === "NET021") theme_id = "getvahomeloan";
    // if (isAutismHeroes) theme_id = "autismHeroes";

    try {
      // Get the static data from s3 for the filtered state else return the default data
      // Get the state list
      const stateList = await (0, _axios.default)("".concat(process.env.REACT_APP_RATE_PRODUCT, "/state.json"));
      // Filter the state which has the county and zipcode
      const propertyStateData = stateList.data.find(d => d.state.code === userStateCode);
      let response;
      if (propertyStateData) {
        const county = propertyStateData.state.county.code;
        const zipcode = propertyStateData.state.county.zipcode;
        response = await (0, _axios.default)("".concat(process.env.REACT_APP_RATE_PRODUCT, "/").concat(theme_id, "/").concat(userStateCode.toLowerCase(), "/").concat(county, "/").concat(zipcode, "/products.json"));
      } else {
        response = await (0, _axios.default)("".concat(process.env.REACT_APP_RATE_PRODUCT, "/").concat(theme_id, "/default.json"));
      }
      const parseValue = (0, _dateFns.parseISO)(response.data.createdAt);
      const dateTime = (0, _dateFns.format)(parseValue, "MM/dd/yyyy hh:mm a");
      setProductCreationTime(dateTime);
      userSession.setWebOffer(JSON.stringify(response.data));
      const purchaseData = response.data.purchase;
      if (purchaseData.CONV_30_YR_FIXED) {
        setPurchaseConv30A(purchaseData.CONV_30_YR_FIXED);
      }
      if (purchaseData.CONV_15_YR_FIXED) {
        setPurchaseConv15A(purchaseData.CONV_15_YR_FIXED);
        setPurchaseConvLimit(purchaseData.CONV_15_YR_FIXED.countyLimit);
      }
      if (purchaseData.FHA_15_YR_FIXED) {
        setPurchaseFha15A(purchaseData.FHA_15_YR_FIXED);
      }
      if (purchaseData.FHA_30_YR_FIXED) {
        setPurchaseFha30A(purchaseData.FHA_30_YR_FIXED);
        setPurchaseFhaLimit(purchaseData.FHA_30_YR_FIXED.countyLimit);
      }
      if (purchaseData.VA_30_YR_FIXED) {
        setPurchaseVa30A(purchaseData.VA_30_YR_FIXED);
      }
      if (purchaseData.VA_15_YR_FIXED) {
        setPurchaseVa15A(purchaseData.VA_15_YR_FIXED);
        setPurchaseVaLimit(purchaseData.VA_15_YR_FIXED.countyLimit);
      }
      if (purchaseData.USDA_15_YR_FIXED) {
        setPurchaseUsda15A(purchaseData.USDA_15_YR_FIXED);
      }
      if (purchaseData.USDA_30_YR_FIXED) {
        setPurchaseUsda30A(purchaseData.USDA_30_YR_FIXED);
        setPurchaseUsdaLimit(purchaseData.USDA_30_YR_FIXED.countyLimit);
      }
      const refinanceData = response.data.cashoutrefinance ? response.data.cashoutrefinance : response.data.refinance;
      if (refinanceData.CONV_30_YR_FIXED) {
        setRefinanceConv30A(refinanceData.CONV_30_YR_FIXED);
      }
      if (refinanceData.CONV_15_YR_FIXED) {
        setRefinanceConv15A(refinanceData.CONV_15_YR_FIXED);
        setRefinanceConvLimit(refinanceData.CONV_15_YR_FIXED.countyLimit);
      }
      if (refinanceData.FHA_15_YR_FIXED) {
        setRefinanceFha15A(refinanceData.FHA_15_YR_FIXED);
      }
      if (refinanceData.FHA_30_YR_FIXED) {
        setRefinanceFha30A(refinanceData.FHA_30_YR_FIXED);
        setRefinanceFhaLimit(refinanceData.FHA_30_YR_FIXED.countyLimit);
      }
      if (refinanceData.VA_30_YR_FIXED) {
        setRefinanceVa30A(refinanceData.VA_30_YR_FIXED);
      }
      if (refinanceData.VA_15_YR_FIXED) {
        setRefinanceVa15A(refinanceData.VA_15_YR_FIXED);
        setRefinanceVaLimit(refinanceData.VA_15_YR_FIXED.countyLimit);
      }
      if (refinanceData.USDA_15_YR_FIXED) {
        setRefinanceUsda15A(refinanceData.USDA_15_YR_FIXED);
      }
      if (refinanceData.USDA_30_YR_FIXED) {
        setRefinanceUsda30A(refinanceData.USDA_30_YR_FIXED);
        setRefinanceUsdaLimit(refinanceData.USDA_30_YR_FIXED.countyLimit);
      }

      //Added by Ankita Porwal - 02/06/2024 - WEB-566 - HomeEquity
      //used to get the home equity 2nd TDRates from the response
      const homeEquityData = response.data.homeEquity;

      // if (homeEquityData['2ND_TD_30_YR_FIXED']) {
      //   setHomeEquity2NDTD30A(homeEquityData['2ND_TD_30_YR_FIXED']);
      // }

      // if (homeEquityData['2ND_TD_20_YR_FIXED']) {
      //   setHomeEquity2NDTD20A(homeEquityData['2ND_TD_20_YR_FIXED']);
      // }

      // if (homeEquityData['2ND_TD_15_YR_FIXED']) {
      //   setHomeEquity2NDTD15A(homeEquityData['2ND_TD_15_YR_FIXED']);
      // }

      // if (homeEquityData['2ND_TD_10_YR_FIXED']) {
      //   setHomeEquity2NDTD10A(homeEquityData['2ND_TD_10_YR_FIXED']);
      // }
      if (homeEquityData) {
        if (homeEquityData['2ND_TD_30_YR_FIXED']) {
          setHomeEquity2NDTD30A(homeEquityData['2ND_TD_30_YR_FIXED']);
          setShowHomeEquityTab(true);
        }
        if (homeEquityData['2ND_TD_20_YR_FIXED']) {
          setHomeEquity2NDTD20A(homeEquityData['2ND_TD_20_YR_FIXED']);
          setShowHomeEquityTab(true);
        }
        if (homeEquityData['2ND_TD_15_YR_FIXED']) {
          setHomeEquity2NDTD15A(homeEquityData['2ND_TD_15_YR_FIXED']);
          setShowHomeEquityTab(true);
        }
        if (homeEquityData['2ND_TD_10_YR_FIXED']) {
          setHomeEquity2NDTD10A(homeEquityData['2ND_TD_10_YR_FIXED']);
          setShowHomeEquityTab(true);
        }
      }
      setShow(true);
      setProductLoading(false);
    } catch (error) {
      setProductLoading(false);
      console.error("err price", error);
    }
  };
  (0, _react.useEffect)(() => {
    if (!_react.default.version.startsWith("17")) {
      console.error("RateQuotes requires react version 17.0.2 in order to avoid react hook error. The current version of react is ".concat(_react.default.version));
    }
    setShow(false);
    // Removing the loading because data rendered too fast no need of loader
    // setLoading(true);

    // Below get the default config data
    getDefaultConfig(themeLeadSource);

    // Below conditions are to determine with tab must be shown
    themeConfig.requestRates.purchase.scenarios.forEach(product => {
      setPurchaseTab(true);
      if (product === "CONV_15_YR_FIXED" || product === "CONV_30_YR_FIXED") {
        setPurchaseConvTab(true);
      }
      if (product === "FHA_15_YR_FIXED" || product === "FHA_30_YR_FIXED") {
        setPurchaseFhaTab(true);
      }
      if (product === "VA_15_YR_FIXED" || product === "VA_30_YR_FIXED") {
        setPurchaseVaTab(true);
      }
      if (product === "USDA_15_YR_FIXED" || product === "USDA_30_YR_FIXED") {
        setPurchaseUsdaTab(true);
      }
    });

    //Added by Ankita -WEB-566
    //used to set the HomeEquity tab when the user clicks on the HomeEquity tab
    themeConfig.requestRates.homeEquity.scenarios.forEach(product => {
      setHomeEquityTab(true);
    });
    const reqRefinanceData = themeConfig.requestRates.cashoutrefinance ? themeConfig.requestRates.cashoutrefinance : themeConfig.requestRates.refinance;
    reqRefinanceData.scenarios.forEach(product => {
      setRefinanceTab(true);
      if (product === "CONV_15_YR_FIXED" || product === "CONV_30_YR_FIXED") {
        setRefinanceConvTab(true);
      }
      if (product === "FHA_15_YR_FIXED" || product === "FHA_30_YR_FIXED") {
        setRefinanceFhaTab(true);
      }
      if (product === "VA_15_YR_FIXED" || product === "VA_30_YR_FIXED") {
        setRefinanceVaTab(true);
      }
      if (product === "USDA_15_YR_FIXED" || product === "USDA_30_YR_FIXED") {
        setRefinanceUsdaTab(true);
      }
    });

    // Get state from public endpoint
    let rechecked_domain = domain;
    if (isAutismHeroes) {
      rechecked_domain = "autismheroes.swmc.com";
    }
    ;
    _axios.default.post(process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE_LIST, {
      companyCode: "SUNWST000",
      domain: rechecked_domain
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      userSession.setStateList(JSON.stringify(response.data));
      dispatch((0, _actions.stateListUpdate)(response.data));
    });

    /* Get client IP and geolocation(3 API) Task LRTV-3 */
    _axios.default.post(process.env.REACT_APP_MAXMIND, {}, {
      timeout: 5000
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => {
      if (response.data !== "IP Not Available" && response.data !== "Invalid Country") {
        let zipcode = response.data.zipcode;
        if (zipcode) {
          _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipcode, {
            headers: {
              "Content-Type": "application/json"
            }
          }, {
            timeout: 15000
          }).then(async response => {
            userSession.setPropertyCounty(response.data.counties[0].code);
            dispatch((0, _actions.stateCountyUpdate)(response.data.counties[0].code));
            userSession.setPropertyState(response.data.state);
            dispatch((0, _actions.countryStateUpdate)(response.data.state));
            _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE + response.data.state, {
              headers: {
                "Content-Type": "application/json"
              }
            }).then(response => {
              setStateName(response.data.stateName);
            });
            let priceForStateConfig = new _PriceForState.default(response.data.state);
            let userReqData;
            if (themeConfig.requestRates.cashoutrefinance) {
              userReqData = {
                purchase: {
                  branchCode: themeConfig.requestRates.purchase.branchCode,
                  creditScore: themeConfig.requestRates.purchase.creditScore,
                  loanAmount: themeConfig.requestRates.purchase.loanAmount,
                  leadSource: themeConfig.requestRates.purchase.leadSource,
                  loanPurpose: themeConfig.requestRates.purchase.loanPurpose,
                  lockPeriod: themeConfig.requestRates.purchase.lockPeriod,
                  matchExactPrice: themeConfig.requestRates.purchase.matchExactPrice,
                  occupancy: themeConfig.requestRates.purchase.occupancy,
                  price: themeConfig.requestRates.purchase.leadSource === "NET007" ? themeConfig.requestRates.purchase.price : priceForStateConfig.getPriceForState(),
                  promoCode: themeConfig.requestRates.purchase.promoCode,
                  propertyCounty: response.data.counties[0].code,
                  propertyState: response.data.state,
                  propertyZipCode: zipcode,
                  propertyTypeKeyword: themeConfig.requestRates.purchase.propertyTypeKeyword,
                  propertyValue: themeConfig.requestRates.purchase.propertyValue,
                  userId: themeConfig.requestRates.purchase.userId,
                  veteran: themeConfig.requestRates.purchase.veteran,
                  scenarios: [themeConfig.requestRates.purchase.scenarios[0], themeConfig.requestRates.purchase.scenarios[1]]
                },
                cashoutrefinance: {
                  branchCode: themeConfig.requestRates.cashoutrefinance.branchCode,
                  creditScore: themeConfig.requestRates.cashoutrefinance.creditScore,
                  loanAmount: themeConfig.requestRates.cashoutrefinance.loanAmount,
                  leadSource: themeConfig.requestRates.cashoutrefinance.leadSource,
                  loanPurpose: themeConfig.requestRates.cashoutrefinance.loanPurpose,
                  lockPeriod: themeConfig.requestRates.cashoutrefinance.lockPeriod,
                  matchExactPrice: themeConfig.requestRates.cashoutrefinance.matchExactPrice,
                  occupancy: themeConfig.requestRates.cashoutrefinance.occupancy,
                  price: themeConfig.requestRates.cashoutrefinance.leadSource === "NET007" ? themeConfig.requestRates.cashoutrefinance.price : priceForStateConfig.getPriceForState(),
                  promoCode: themeConfig.requestRates.cashoutrefinance.promoCode,
                  propertyCounty: response.data.counties[0].code,
                  propertyState: response.data.state,
                  propertyZipCode: zipcode,
                  propertyTypeKeyword: themeConfig.requestRates.cashoutrefinance.propertyTypeKeyword,
                  propertyValue: themeConfig.requestRates.cashoutrefinance.propertyValue,
                  userId: themeConfig.requestRates.cashoutrefinance.userId,
                  veteran: themeConfig.requestRates.cashoutrefinance.veteran,
                  scenarios: [themeConfig.requestRates.cashoutrefinance.scenarios[0], themeConfig.requestRates.cashoutrefinance.scenarios[1]]
                }
              };
            } else {
              userReqData = {
                purchase: {
                  branchCode: themeConfig.requestRates.purchase.branchCode,
                  creditScore: themeConfig.requestRates.purchase.creditScore,
                  loanAmount: themeConfig.requestRates.purchase.loanAmount,
                  leadSource: themeConfig.requestRates.purchase.leadSource,
                  loanPurpose: themeConfig.requestRates.purchase.loanPurpose,
                  lockPeriod: themeConfig.requestRates.purchase.lockPeriod,
                  matchExactPrice: themeConfig.requestRates.purchase.matchExactPrice,
                  occupancy: themeConfig.requestRates.purchase.occupancy,
                  price: themeConfig.requestRates.purchase.leadSource === "NET007" ? themeConfig.requestRates.purchase.price : priceForStateConfig.getPriceForState(),
                  promoCode: themeConfig.requestRates.purchase.promoCode,
                  propertyCounty: response.data.counties[0].code,
                  propertyState: response.data.state,
                  propertyZipCode: zipcode,
                  propertyTypeKeyword: themeConfig.requestRates.purchase.propertyTypeKeyword,
                  propertyValue: themeConfig.requestRates.purchase.propertyValue,
                  userId: themeConfig.requestRates.purchase.userId,
                  veteran: themeConfig.requestRates.purchase.veteran,
                  scenarios: [themeConfig.requestRates.purchase.scenarios[0], themeConfig.requestRates.purchase.scenarios[1]]
                },
                refinance: {
                  branchCode: themeConfig.requestRates.refinance.branchCode,
                  creditScore: themeConfig.requestRates.refinance.creditScore,
                  loanAmount: themeConfig.requestRates.refinance.loanAmount,
                  leadSource: themeConfig.requestRates.refinance.leadSource,
                  loanPurpose: themeConfig.requestRates.refinance.loanPurpose,
                  lockPeriod: themeConfig.requestRates.refinance.lockPeriod,
                  matchExactPrice: themeConfig.requestRates.refinance.matchExactPrice,
                  occupancy: themeConfig.requestRates.refinance.occupancy,
                  price: themeConfig.requestRates.refinance.leadSource === "NET007" ? themeConfig.requestRates.refinance.price : priceForStateConfig.getPriceForState(),
                  promoCode: themeConfig.requestRates.refinance.promoCode,
                  propertyCounty: response.data.counties[0].code,
                  propertyState: response.data.state,
                  propertyZipCode: zipcode,
                  propertyTypeKeyword: themeConfig.requestRates.refinance.propertyTypeKeyword,
                  propertyValue: themeConfig.requestRates.refinance.propertyValue,
                  userId: themeConfig.requestRates.refinance.userId,
                  veteran: themeConfig.requestRates.refinance.veteran,
                  scenarios: [themeConfig.requestRates.refinance.scenarios[0], themeConfig.requestRates.refinance.scenarios[1]]
                },
                // WEB-566 -- used to get the HomeEquity 2nd TDRates
                homeEquity: {
                  branchCode: themeConfig.requestRates.homeEquity.branchCode,
                  creditScore: themeConfig.requestRates.homeEquity.creditScore,
                  loanAmount: themeConfig.requestRates.homeEquity.loanAmount,
                  leadSource: themeConfig.requestRates.homeEquity.leadSource,
                  loanPurpose: themeConfig.requestRates.homeEquity.loanPurpose,
                  lockPeriod: themeConfig.requestRates.homeEquity.lockPeriod,
                  matchExactPrice: themeConfig.requestRates.homeEquity.matchExactPrice,
                  occupancy: themeConfig.requestRates.homeEquity.occupancy,
                  price: themeConfig.requestRates.homeEquity.leadSource === "NET007" ? themeConfig.requestRates.homeEquity.price : priceForStateConfig.getPriceForState(),
                  promoCode: themeConfig.requestRates.homeEquity.promoCode,
                  propertyCounty: response.data.counties[0].code,
                  propertyState: response.data.state,
                  propertyZipCode: zipcode,
                  propertyTypeKeyword: themeConfig.requestRates.homeEquity.propertyTypeKeyword,
                  propertyValue: themeConfig.requestRates.homeEquity.propertyValue,
                  userId: themeConfig.requestRates.homeEquity.userId,
                  veteran: themeConfig.requestRates.homeEquity.veteran,
                  scenarios: [themeConfig.requestRates.homeEquity.scenarios[0], themeConfig.requestRates.homeEquity.scenarios[1]]
                }
              };
            }

            // get the price scenario
            await getPrice(userReqData.purchase.leadSource, userReqData.purchase.propertyState);
            saveInitialRequestData(userReqData);
            userSession.setPropertyZipCode(zipcode);
            return userReqData;
          }).then(async userReqData => {
            setNoCCProgram(themeConfig.isNoCCProgram);
          }).catch(error => {
            locationError();
            console.log("zipcode Error", error);
          });
        } else {
          locationError();
        }
      } else {
        console.log(response.data); // Show Error message from lambda function
        locationError();
      }
    }).catch(error => {
      console.log(error);
      locationError(error);
    });
    userSession.setCustomQuote(customRateQuote);
    savePurchaseCVNDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(() => {
    if (themeLeadSource === 'INHNPORT-017' || themeLeadSource === "NET021") {
      setCustomButton(false);
    }
    if (themeLeadSource === "NET021") {
      handleLoanPurposeTabs("purchase");
      handlePurchaseProdTabs("va");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeLeadSource]);
  const handleLoanPurpose = loanPurpose => {
    // console.log(loanPurpose);
    let loanType = "Refinance";
    switch (loanPurpose) {
      case 0:
        loanType = "Purchase";
        break;
      case 1:
        loanType = "Refinance";
        break;
      case 2:
        loanType = "Cash Out Refi";
        break;
      //no default
    }
    return loanType;
  };

  // Function to determine if rates are available
  const areRatesAvailable = rateObj => rateObj && rateObj.rate !== undefined && rateObj.rate !== null && rateObj.rate !== '';

  // Initial call to handle tabs based on refinanceTab and defaultRefinanceTab
  (0, _react.useEffect)(() => {
    if (refinanceTab && defaultRefinanceTab) {
      handleRefinanceProdTabs(defaultRefinanceTab, defaultRefinanceTab);
    }
  }, [refinanceTab, defaultRefinanceTab]);

  // Effect to check rate availability and set default tabs
  (0, _react.useEffect)(() => {
    if (areRatesAvailable(purchaseConv30A)) setPurchaseConvRateAvailable(true);
    if (areRatesAvailable(purchaseFha30A)) setPurchaseFhaRateAvailable(true);
    if (areRatesAvailable(refinanceConv30A)) setRefinanceConvRateAvailable(true);
    if (areRatesAvailable(refinanceFha30A)) setRefinanceFhaRateAvailable(true);
    if (purchaseConvRateAvailable && purchaseFhaRateAvailable) {
      const lowestPurchaseRate = purchaseConv30A.rate < purchaseFha30A.rate ? "conventional" : "fha";
      setDefaultPurchaseTab(lowestPurchaseRate);
      handlePurchaseProdTabs(lowestPurchaseRate);
    }
    if (refinanceConvRateAvailable && refinanceFhaRateAvailable) {
      const lowestRefinanceRate = refinanceConv30A.rate < refinanceFha30A.rate ? "conventional" : "fha";
      setDefaultRefinanceTab(lowestRefinanceRate);
    }
    if (purchaseConvRateAvailable && purchaseFhaRateAvailable && refinanceConvRateAvailable && refinanceFhaRateAvailable) {
      // New logic to determine the default loan program tab
      const allRates = [{
        type: "purchase",
        product: "conventional",
        rate: purchaseConv30A.rate
      }, {
        type: "purchase",
        product: "fha",
        rate: purchaseFha30A.rate
      }, {
        type: "refinance",
        product: "conventional",
        rate: refinanceConv30A.rate
      }, {
        type: "refinance",
        product: "fha",
        rate: refinanceFha30A.rate
      }];
      const lowestRateObj = allRates.reduce((lowest, current) => current.rate < lowest.rate ? current : lowest);
      if (lowestRateObj.type === "refinance") {
        setDefaultLoanProgramTab("refinance");
        setSelectTab(lowestRateObj.product);
        handleLoanPurposeTabs("refinance", lowestRateObj.product);
        setDefaultRefinanceTab(lowestRateObj.product);
        handleRefinanceProdTabs(lowestRateObj.product);
        //  setDefaultPurchaseTab("conventional");
        //   handlePurchaseProdTabs("conventional"); 
      } else {
        setDefaultLoanProgramTab(defaultProduct);
        setSelectTab(lowestRateObj.product);
        handleLoanPurposeTabs(defaultProduct, lowestRateObj.product);
        setDefaultPurchaseTab(lowestRateObj.product);
        handlePurchaseProdTabs(lowestRateObj.product);
      }
      setLoadingRates(false);
    }
  }, [purchaseConv30A, purchaseFha30A, refinanceConv30A, refinanceFha30A, purchaseConvRateAvailable, purchaseFhaRateAvailable, refinanceConvRateAvailable, refinanceFhaRateAvailable]);
  if (loadingRates) {
    return /*#__PURE__*/_react.default.createElement("p", null, "Loading rates...");
  }
  return /*#__PURE__*/_react.default.createElement("div", null, themeLeadSource !== "BL617RAN003" ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "text-center shadow-sm d-flex justify-content-center rate-title-bg-color",
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "py-1",
    id: "todayRatesTitle"
  }, customRateQuote ? /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-white"
  }, "YOUR CUSTOM QUOTE") : /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-white"
  }, "TODAY'S RATES", " ", stateName ? "FOR " + stateName.toUpperCase() : null)))) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "ratesSection"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: !show ? "d-none" : null
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    className: "justify-content-center pt-1",
    defaultActiveKey: defaultLoanProgramTab,
    id: "loan-purpose-tabs",
    onSelect: k => handleLoanPurposeTabs(k, selectTab)
  }, purchaseTab === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showPurchaseRates ? "d-flex justify-content-center" : "d-none",
    eventKey: "purchase",
    title: "Purchase Rates"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    className: "justify-content-center pt-1",
    defaultActiveKey: "".concat(themeLeadSource === "NET021" ? "va" : defaultPurchaseTab),
    id: "products-purchase-tabs",
    onSelect: k => handlePurchaseProdTabs(k)
  }, purchaseConvTab === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showPurchaseCvnRates ? "d-flex justify-content-center convRates conv-wrapper" : "d-none convRates conv-wrapper",
    eventKey: "conventional",
    title: "Conventional"
  }, props.offertext !== "" && !productLoading && (purchaseConv15A.match || purchaseConv30A.match) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "".concat(purchaseConv15A.rate === (purchaseConv15A.aprEstimated ? purchaseConv15A.aprEstimated : purchaseConv15A.apr) || purchaseConv30A.rate === (purchaseConv30A.aprEstimated ? purchaseConv30A.aprEstimated : purchaseConv30A.apr) && noCCProgram === true ? "d-block" : "d-none"),
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center noClosingCost w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "No Closing Costs!"))), purchaseConv15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: purchaseConv15A.rate === (purchaseConv15A.aprEstimated ? purchaseConv15A.aprEstimated : purchaseConv15A.apr) ||
    // noCCProgram === true ||
    (purchaseConv15A.aprEstimated ? purchaseConv15A.aprEstimated : purchaseConv15A.apr) - purchaseConv15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_conv15A",
    leadSource: themeLeadSource,
    data: purchaseConv15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), purchaseConv15A.rate === (purchaseConv15A.aprEstimated ? purchaseConv15A.aprEstimated : purchaseConv15A.apr) ||
  // noCCProgram === true ||
  (purchaseConv15A.aprEstimated ? purchaseConv15A.aprEstimated : purchaseConv15A.apr) - purchaseConv15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseConv15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseConv15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseConv15A.aprEstimated ? purchaseConv15A.aprEstimated : purchaseConv15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med"
  }, "(Rate", " ", purchaseConv15A.rate === (purchaseConv15A.aprEstimated ? purchaseConv15A.aprEstimated : purchaseConv15A.apr) ||
  // noCCProgram === true ||
  (purchaseConv15A.aprEstimated ? purchaseConv15A.aprEstimated : purchaseConv15A.apr) - purchaseConv15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, purchaseConv30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: purchaseConv30A.rate === (purchaseConv30A.aprEstimated ? purchaseConv30A.aprEstimated : purchaseConv30A.apr) ||
    // noCCProgram === true ||
    (purchaseConv30A.aprEstimated ? purchaseConv30A.aprEstimated : purchaseConv30A.apr) - purchaseConv30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_conv30A",
    leadSource: themeLeadSource,
    data: purchaseConv30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), purchaseConv30A.rate === (purchaseConv30A.aprEstimated ? purchaseConv30A.aprEstimated : purchaseConv30A.apr) ||
  // noCCProgram === true ||
  (purchaseConv30A.aprEstimated ? purchaseConv30A.aprEstimated : purchaseConv30A.apr) - purchaseConv30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseConv30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseConv30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseConv30A.aprEstimated ? purchaseConv30A.aprEstimated : purchaseConv30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med"
  }, "(Rate", " ", purchaseConv30A.rate === (purchaseConv30A.aprEstimated ? purchaseConv30A.aprEstimated : purchaseConv30A.apr) ||
  // noCCProgram === true ||
  (purchaseConv30A.aprEstimated ? purchaseConv30A.aprEstimated : purchaseConv30A.apr) - purchaseConv30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null) : null, purchaseFhaTab === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showPurchaseFHARates ? "d-flex justify-content-center fhaRates" : "d-none fhaRates",
    eventKey: "fha",
    title: "FHA"
  }, props.offertext !== "" && !productLoading && (purchaseFha15A.match || purchaseFha30A.match) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))) : null, !purchaseFha15A.match && !purchaseFha30A.match ? /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center pt-3"
  }, "We are unable to display any products at this time. Please call us at", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+18445625337",
    className: "text-decoration-none ratesatagnewchanges"
  }, "844-562-5337"), " ", "to discuss more options.") : null, purchaseFha15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: purchaseFha15A.rate === purchaseFha15A.apr || (purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr) === 0 || (purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr) - purchaseFha15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_fha15A",
    leadSource: themeLeadSource,
    data: purchaseFha15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), purchaseFha15A.rate === (purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr) || (purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr) === 0 || (purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr) - purchaseFha15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseFha15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseFha15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", purchaseFha15A.rate === (purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr) || (purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr) === 0 || (purchaseFha15A.aprEstimated ? purchaseFha15A.aprEstimated : purchaseFha15A.apr) - purchaseFha15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, purchaseFha30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: purchaseFha30A.rate === (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) || (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) === 0 || (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) - purchaseFha30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_fha30A",
    leadSource: themeLeadSource,
    data: purchaseFha30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), purchaseFha30A.rate === (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) || (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) === 0 || (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) - purchaseFha30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseFha30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseFha30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", purchaseFha30A.rate === (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) || (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) === 0 || (purchaseFha30A.aprEstimated ? purchaseFha30A.aprEstimated : purchaseFha30A.apr) - purchaseFha30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null) : null, purchaseVaTab === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showPurchaseVARates ? "d-flex justify-content-center convRates" : "d-none convRates",
    eventKey: "va",
    title: "VA"
  }, props.offertext !== "" && !productLoading && (purchaseVa15A.match || purchaseVa30A.match) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))) : null, !purchaseVa15A.match && !purchaseVa30A.match ? /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center pt-3"
  }, "We are unable to display any products at this time. Please call us at", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+18445625337",
    className: "text-decoration-none ratesatagnewchanges"
  }, "844-562-5337"), " ", "to discuss more options.") : null, themeLeadSource !== "BL617RAN003" && purchaseVa15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: purchaseVa15A.rate === (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) || (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) === 0 || (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) - purchaseVa15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_va15A",
    leadSource: themeLeadSource,
    data: purchaseVa15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), purchaseVa15A.rate === (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) || (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) === 0 || (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) - purchaseVa15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseVa15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseVa15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", purchaseVa15A.rate === (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) || (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) === 0 || (purchaseVa15A.aprEstimated ? purchaseVa15A.aprEstimated : purchaseVa15A.apr) - purchaseVa15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, purchaseVa30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: purchaseVa30A.rate === (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) || (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) === 0 || (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) - purchaseVa30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_va30A",
    leadSource: themeLeadSource,
    data: purchaseVa30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), purchaseVa30A.rate === (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) || (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) === 0 || (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) - purchaseVa30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseVa30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseVa30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", purchaseVa30A.rate === (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) || (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) === 0 || (purchaseVa30A.aprEstimated ? purchaseVa30A.aprEstimated : purchaseVa30A.apr) - purchaseVa30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null) : null, purchaseUsdaTab === true && themeLeadSource !== "TEXAS-TV" && themeLeadSource !== "NET007" ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showPurchaseUsdaRates ? "d-flex justify-content-center convRates" : "d-none convRates",
    eventKey: "usda",
    title: "USDA"
  }, props.offertext !== "" && !productLoading && (purchaseUsda15A.match || purchaseUsda30A.match) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))) : null, !purchaseUsda15A.match && !purchaseUsda30A.match ? /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center pt-3"
  }, "We are unable to display any products at this time. Please call us at", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+18445625337",
    className: "text-decoration-none ratesatagnewchanges"
  }, "844-562-5337"), " ", "to discuss more options.") : null, themeLeadSource !== "BL617RAN003" && purchaseUsda15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: purchaseUsda15A.rate === (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) || (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) === 0 || (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) - purchaseUsda15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_usda15A",
    leadSource: themeLeadSource,
    data: purchaseUsda15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), purchaseUsda15A.rate === (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) || (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) === 0 || (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) - purchaseUsda15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseUsda15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseUsda15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", purchaseUsda15A.rate === (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) || (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) === 0 || (purchaseUsda15A.aprEstimated ? purchaseUsda15A.aprEstimated : purchaseUsda15A.apr) - purchaseUsda15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, purchaseUsda30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: purchaseUsda30A.rate === (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) || (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) === 0 || (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) - purchaseUsda30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_usda30A",
    leadSource: themeLeadSource,
    data: purchaseUsda30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), purchaseUsda30A.rate === (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) || (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) === 0 || (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) - purchaseUsda30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseUsda30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseUsda30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", purchaseUsda30A.rate === (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) || (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) === 0 || (purchaseUsda30A.aprEstimated ? purchaseUsda30A.aprEstimated : purchaseUsda30A.apr) - purchaseUsda30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null) : null)) : null, homeEquityTab === true && showHomeEquityTab ?
  /*#__PURE__*/
  // Check if homeEquityTab is true
  _react.default.createElement(_reactBootstrap.Tab // Render Tab component
  , {
    as: _reactBootstrap.Row,
    className: showHomeEquityRates ? "d-flex justify-content-center" : "d-none",
    eventKey: "homeEquity",
    title: "Home Equity Closed End Rates"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs // Render Tabs component
  , {
    className: "justify-content-center",
    id: "products-homeEquity-tabs",
    onSelect: () => handleHomeEquityProdTabs() // Call handleHomeEquityProdTabs when tab is selected
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab // Render inner Tab component
  , {
    as: _reactBootstrap.Row,
    className: showHomeEquityRates ? "d-flex justify-content-center homeEquityRates homeEquity-wrapper" : "d-none homeEquityRates homeEquity-wrapper",
    eventKey: "2ndTd"
  }, props.offertext !== "" &&
  // Render offertext if it's not empty and product is not loading
  !productLoading && (homeEquity2NDTD30A.match || homeEquity2NDTD15A.match) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "".concat(homeEquity2NDTD15A.rate === (homeEquity2NDTD15A.aprEstimated ? homeEquity2NDTD15A.aprEstimated : homeEquity2NDTD15A.apr) || homeEquity2NDTD30A.rate === (homeEquity2NDTD30A.aprEstimated ? homeEquity2NDTD30A.aprEstimated : homeEquity2NDTD30A.apr) && noCCProgram === true ? "d-block" : "d-none"),
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center noClosingCost w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "No Closing Costs!"))), homeEquity2NDTD15A.match === true ?
  /*#__PURE__*/
  // Render details if 15 years match
  _react.default.createElement(_reactBootstrap.Col, {
    lg: homeEquity2NDTD15A.rate === (homeEquity2NDTD15A.aprEstimated ? homeEquity2NDTD15A.aprEstimated : homeEquity2NDTD15A.apr) || (homeEquity2NDTD15A.aprEstimated ? homeEquity2NDTD15A.aprEstimated : homeEquity2NDTD15A.apr) - homeEquity2NDTD15A.rate <= 0.01 ? 5 // set lg to 3 if conditions met, else set to 5
    : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_2nd_td15A",
    leadSource: themeLeadSource,
    data: homeEquity2NDTD15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), homeEquity2NDTD15A.rate === (homeEquity2NDTD15A.aprEstimated ? homeEquity2NDTD15A.aprEstimated : homeEquity2NDTD15A.apr) || (homeEquity2NDTD15A.aprEstimated ? homeEquity2NDTD15A.aprEstimated : homeEquity2NDTD15A.apr) - homeEquity2NDTD15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD15A.aprEstimated ? homeEquity2NDTD15A.aprEstimated : homeEquity2NDTD15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med"
  }, "(Rate", " ", homeEquity2NDTD15A.rate === (homeEquity2NDTD15A.aprEstimated ? homeEquity2NDTD15A.aprEstimated : homeEquity2NDTD15A.apr) || (homeEquity2NDTD15A.aprEstimated ? homeEquity2NDTD15A.aprEstimated : homeEquity2NDTD15A.apr) - homeEquity2NDTD15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, homeEquity2NDTD30A.match === true ?
  /*#__PURE__*/
  // Render details if 30 years match
  _react.default.createElement(_reactBootstrap.Col, {
    lg: homeEquity2NDTD30A.rate === (homeEquity2NDTD30A.aprEstimated ? homeEquity2NDTD30A.aprEstimated : homeEquity2NDTD30A.apr) || (homeEquity2NDTD30A.aprEstimated ? homeEquity2NDTD30A.aprEstimated : homeEquity2NDTD30A.apr) - homeEquity2NDTD30A.rate <= 0.01 ? 5 // set lg to 3 if conditions met, else set to 5
    : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_2nd_td30A",
    leadSource: themeLeadSource,
    data: homeEquity2NDTD30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), homeEquity2NDTD30A.rate === (homeEquity2NDTD30A.aprEstimated ? homeEquity2NDTD30A.aprEstimated : homeEquity2NDTD30A.apr) || (homeEquity2NDTD30A.aprEstimated ? homeEquity2NDTD30A.aprEstimated : homeEquity2NDTD30A.apr) - homeEquity2NDTD30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: homeEquity2NDTD30A.aprEstimated ? homeEquity2NDTD30A.aprEstimated : homeEquity2NDTD30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med"
  }, "(Rate", " ", homeEquity2NDTD30A.rate === (homeEquity2NDTD30A.aprEstimated ? homeEquity2NDTD30A.aprEstimated : homeEquity2NDTD30A.apr) || (homeEquity2NDTD30A.aprEstimated ? homeEquity2NDTD30A.aprEstimated : homeEquity2NDTD30A.apr) - homeEquity2NDTD30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null))) : null, refinanceTab === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showRefinanceRates ? "d-flex justify-content-center" : "d-none",
    eventKey: "refinance",
    title: "Refinance Rates"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    className: "justify-content-center pt-1",
    defaultActiveKey: "".concat(themeLeadSource === "NET021" ? "va" : defaultRefinanceTab),
    id: "products-refinance-tabs",
    onSelect: k => handleRefinanceProdTabs(k, defaultRefinanceTab)
  }, refinanceConvTab === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showRefinanceCvnRates ? "d-flex justify-content-center convRates conv-wrapper" : "d-none convRates conv-wrapper",
    eventKey: "conventional",
    title: "Conventional"
  }, props.offertext !== "" && !productLoading && (refinanceConv15A.match || refinanceConv30A.match) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "".concat(refinanceConv15A.rate === (refinanceConv15A.aprEstimated ? refinanceConv15A.aprEstimated : refinanceConv15A.apr) || refinanceConv30A.rate === (refinanceConv30A.aprEstimated ? refinanceConv30A.aprEstimated : refinanceConv30A.apr) && noCCProgram === true ? "d-block" : "d-none"),
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center noClosingCost w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "No Closing Costs!"))), refinanceConv15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: refinanceConv15A.rate === (refinanceConv15A.aprEstimated ? refinanceConv15A.aprEstimated : refinanceConv15A.apr) ||
    // noCCProgram === true ||
    (refinanceConv15A.aprEstimated ? refinanceConv15A.aprEstimated : refinanceConv15A.apr) - refinanceConv15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_conv15A",
    leadSource: themeLeadSource,
    data: refinanceConv15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), refinanceConv15A.rate === (refinanceConv15A.aprEstimated ? refinanceConv15A.aprEstimated : refinanceConv15A.apr) ||
  // noCCProgram === true ||
  (refinanceConv15A.aprEstimated ? refinanceConv15A.aprEstimated : refinanceConv15A.apr) - refinanceConv15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceConv15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceConv15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceConv15A.aprEstimated ? refinanceConv15A.aprEstimated : refinanceConv15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med"
  }, "(Rate", " ", refinanceConv15A.rate === (refinanceConv15A.aprEstimated ? refinanceConv15A.aprEstimated : refinanceConv15A.apr) ||
  // noCCProgram === true ||
  (refinanceConv15A.aprEstimated ? refinanceConv15A.aprEstimated : refinanceConv15A.apr) - refinanceConv15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, refinanceConv30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: refinanceConv30A.rate === (refinanceConv30A.aprEstimated ? refinanceConv30A.aprEstimated : refinanceConv30A.apr) ||
    // noCCProgram === true ||
    (refinanceConv30A.aprEstimated ? refinanceConv30A.aprEstimated : refinanceConv30A.apr) - refinanceConv30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_conv30A",
    leadSource: themeLeadSource,
    data: refinanceConv30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), refinanceConv30A.rate === (refinanceConv30A.aprEstimated ? refinanceConv30A.aprEstimated : refinanceConv30A.apr) ||
  // noCCProgram === true ||
  (refinanceConv30A.aprEstimated ? refinanceConv30A.aprEstimated : refinanceConv30A.apr) - refinanceConv30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceConv30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceConv30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceConv30A.aprEstimated ? refinanceConv30A.aprEstimated : refinanceConv30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med"
  }, "(Rate", " ", refinanceConv30A.rate === (refinanceConv30A.aprEstimated ? refinanceConv30A.aprEstimated : refinanceConv30A.apr) ||
  // noCCProgram === true ||
  (refinanceConv30A.aprEstimated ? refinanceConv30A.aprEstimated : refinanceConv30A.apr) - refinanceConv30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null) : null, refinanceFhaTab === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showRefinanceFHARates ? "d-flex justify-content-center fhaRates" : "d-none fhaRates",
    eventKey: "fha",
    title: "FHA"
  }, props.offertext !== "" && !productLoading && (refinanceFha15A.match || refinanceFha30A.match) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))), " ") : null, !refinanceFha15A.match && !refinanceFha30A.match ? /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center pt-3"
  }, "We are unable to display any products at this time. Please call us at", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+18445625337",
    className: "text-decoration-none ratesatagnewchanges"
  }, "844-562-5337"), " ", "to discuss more options.") : null, refinanceFha15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: refinanceFha15A.rate === refinanceFha15A.apr || (refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr) === 0 || (refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr) - refinanceFha15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_fha15A",
    leadSource: themeLeadSource,
    data: refinanceFha15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), refinanceFha15A.rate === (refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr) || (refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr) === 0 || (refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr) - refinanceFha15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceFha15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceFha15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", refinanceFha15A.rate === (refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr) || (refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr) === 0 || (refinanceFha15A.aprEstimated ? refinanceFha15A.aprEstimated : refinanceFha15A.apr) - refinanceFha15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, refinanceFha30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: refinanceFha30A.rate === (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) || (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) === 0 || (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) - refinanceFha30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_fha30A",
    leadSource: themeLeadSource,
    data: refinanceFha30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), refinanceFha30A.rate === (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) || (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) === 0 || (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) - refinanceFha30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceFha30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceFha30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", refinanceFha30A.rate === (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) || (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) === 0 || (refinanceFha30A.aprEstimated ? refinanceFha30A.aprEstimated : refinanceFha30A.apr) - refinanceFha30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null) : null, refinanceVaTab === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showRefinanceVARates ? "d-flex justify-content-center convRates" : "d-none convRates",
    eventKey: "va",
    title: "VA"
  }, props.offertext !== "" && !productLoading && (refinanceVa15A.match || refinanceVa30A.match) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))) : null, !refinanceVa15A.match && !refinanceVa30A.match ? /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center pt-3"
  }, "We are unable to display any products at this time. Please call us at", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+18445625337",
    className: "text-decoration-none ratesatagnewchanges"
  }, "844-562-5337"), " ", "to discuss more options.") : null, themeLeadSource !== "BL617RAN003" && refinanceVa15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: refinanceVa15A.rate === (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) || (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) === 0 || (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) - refinanceVa15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_va15A",
    leadSource: themeLeadSource,
    data: refinanceVa15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), refinanceVa15A.rate === (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) || (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) === 0 || (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) - refinanceVa15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceVa15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceVa15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", refinanceVa15A.rate === (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) || (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) === 0 || (refinanceVa15A.aprEstimated ? refinanceVa15A.aprEstimated : refinanceVa15A.apr) - refinanceVa15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, refinanceVa30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: refinanceVa30A.rate === (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) || (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) === 0 || (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) - refinanceVa30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_va30A",
    leadSource: themeLeadSource,
    data: refinanceVa30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), refinanceVa30A.rate === (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) || (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) === 0 || (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) - refinanceVa30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceVa30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceVa30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", refinanceVa30A.rate === (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) || (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) === 0 || (refinanceVa30A.aprEstimated ? refinanceVa30A.aprEstimated : refinanceVa30A.apr) - refinanceVa30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null) : null, refinanceUsdaTab === true && themeLeadSource !== "TEXAS-TV" && themeLeadSource !== "NET007" ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    as: _reactBootstrap.Row,
    className: showRefinanceUsdaRates ? "d-flex justify-content-center convRates" : "d-none convRates",
    eventKey: "usda",
    title: "USDA"
  }, props.offertext !== "" && !productLoading && (refinanceUsda15A.match || refinanceUsda30A.match) ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-block",
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center w-auto textBlue poppins-med py-2 mb-0"
  }, /*#__PURE__*/_react.default.createElement("strong", null, props.offertext))) : null, !refinanceUsda15A.match && !refinanceUsda30A.match ? /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-center pt-3"
  }, "We are unable to display any products at this time. Please call us at", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:+18445625337",
    className: "text-decoration-none ratesatagnewchanges"
  }, "844-562-5337"), " ", "to discuss more options.") : null, themeLeadSource !== "BL617RAN003" && refinanceUsda15A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: refinanceUsda15A.rate === (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) || (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) === 0 || (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) - refinanceUsda15A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_usda15A",
    leadSource: themeLeadSource,
    data: refinanceUsda15A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "15 YR FIXED"), refinanceUsda15A.rate === (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) || (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) === 0 || (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) - refinanceUsda15A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceUsda15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceUsda15A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", refinanceUsda15A.rate === (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) || (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) === 0 || (refinanceUsda15A.aprEstimated ? refinanceUsda15A.aprEstimated : refinanceUsda15A.apr) - refinanceUsda15A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null, refinanceUsda30A.match === true ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: refinanceUsda30A.rate === (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) || (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) === 0 || (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) - refinanceUsda30A.rate <= 0.01 ? 3 : 5,
    className: "textBlue poppins-black text-center pt-3"
  }, /*#__PURE__*/_react.default.createElement(_applynow.ApplyNow, {
    id: "appNow_usda30A",
    leadSource: themeLeadSource,
    data: refinanceUsda30A
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "textBlue poppins-bold"
  }, "30 YR FIXED"), refinanceUsda30A.rate === (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) || (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) === 0 || (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) - refinanceUsda30A.rate <= 0.01 ? /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceUsda30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "reducefontSize"
  }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceUsda30A.rate,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  }), " ", "/", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr,
    displayType: "text",
    suffix: "%",
    decimalScale: 3,
    fixedDecimalScale: true
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: "fontSizeRateAprText textBlue poppins-med pt-0",
    style: {
      fontSize: "1rem"
    }
  }, "(Rate", " ", refinanceUsda30A.rate === (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) || (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) === 0 || (refinanceUsda30A.aprEstimated ? refinanceUsda30A.aprEstimated : refinanceUsda30A.apr) - refinanceUsda30A.rate <= 0.01 ? "&" : "/", " ", "APR)"), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement("h3", {
    className: "lbl-Apply"
  }, /*#__PURE__*/_react.default.createElement("strong", null, themeLeadSource === "NET007" ? "Get Quote" : "Apply Now")) : null)) : null) : null)) : ""))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, customRateQuote ? /*#__PURE__*/_react.default.createElement(_rates2.default, {
    leadSource: themeLeadSource,
    phoneNumber: props.phoneNumber,
    phoneText: props.phoneText
  }) : ""), themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: !show ? "d-none" : null
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "textBlue poppins-med d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("hr", null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 6,
    className: "btn-cq-wrapper text-center"
  }, customButton ? /*#__PURE__*/_react.default.createElement(_reactScrollIntoView.default, {
    smooth: true,
    selector: "#todayRatesTitle"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "cyanButton my-0 btn-cq",
    onClick: () => {
      setCustomButton(false);
      setShowDescription(false);
      setCustomRateQuote(true);
      setShow(false);
    }
  }, "Customize Quote")) : null))) : null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: true,
    className: "text-center text-white mainBody"
  }, customButton || showDescription ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showPurchaseRates ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex justify-content-center"
  }, themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: "10",
    md: "8",
    className: "pt-2 mt-2 ratesTitle text-center mainBody",
    style: {
      color: "rgb(14, 62, 155)"
    }
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: showPurchaseCvnRates ? "mb-0" : " d-none"
  }, handleLoanPurpose(themePurchaseLoanPurpose), " ", themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? "| No Subordinate Financing " : null, "| ", defaultCreditScore, " FICO"), showPurchaseCvnRates ? /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", purchaseConvLimit ? " Maximum loan amount may vary for your county." : null, /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, ".") : null, /*#__PURE__*/_react.default.createElement("h6", {
    className: showPurchaseFHARates && (purchaseFha15A.match === true || purchaseFha30A.match === true) ? "mb-0" : " d-none"
  }, handleLoanPurpose(themePurchaseLoanPurpose), " ", themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? "| No Subordinate Financing " : null, "| ", defaultCreditScore, " FICO"), showPurchaseFHARates && (purchaseFha15A.match === true || purchaseFha30A.match === true) ? /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", purchaseFhaLimit ? " Maximum loan amount may vary for your county." : null, /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, ".") : null, /*#__PURE__*/_react.default.createElement("h6", {
    className: showPurchaseVARates && (purchaseVa15A.match === true || purchaseVa30A.match === true) ? "mb-0" : " d-none"
  }, handleLoanPurpose(themePurchaseLoanPurpose), " ", themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? "| No Subordinate Financing " : null, "| ", defaultCreditScore, " FICO"), showPurchaseVARates && (purchaseVa15A.match === true || purchaseVa30A.match === true) ? /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", purchaseVaLimit ? " Maximum loan amount may vary for your county." : null, /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, ".") : null, /*#__PURE__*/_react.default.createElement("h6", {
    className: showPurchaseUsdaRates && (purchaseUsda15A.match === true || purchaseUsda30A.match === true) ? "mb-0" : " d-none"
  }, handleLoanPurpose(themePurchaseLoanPurpose), " ", themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? "| No Subordinate Financing " : null, "| ", defaultCreditScore, " FICO"), showPurchaseUsdaRates && (purchaseUsda15A.match === true || purchaseUsda30A.match === true) ? /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", purchaseUsdaLimit ? " Maximum loan amount may vary for your county." : null, /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, ".") : null, themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? /*#__PURE__*/_react.default.createElement("h6", null, document.getElementsByClassName("taca_app") && document.getElementsByClassName("taca_app").length === 1 ? "This Lender Credit is an exclusive offer to the members of TACA that register through this site. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non-transferable and cannot be combined with any other offer." : "This Lender Credit is an exclusive offer to the clients on transactions wherein Sun West Mortgage Company, Inc. is the lender. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non-transferable, subject to change or cancellation without notice except as required by law and cannot be combined with any other offer.") : null) : null) : null), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showHomeEquityRates ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex justify-content-center"
  }, themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: "10",
    md: "8",
    className: "pt-2 mt-2 ratesTitle text-center mainBody",
    style: {
      color: "rgb(14, 62, 155)"
    }
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: showHomeEquity2ndTDRates ? "mb-0" : " d-none"
  }, defaultCreditScore, " FICO"), /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", "Maximum loan amount may vary for your county.", /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, "."), themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? /*#__PURE__*/_react.default.createElement("h6", null, document.getElementsByClassName("taca_app") && document.getElementsByClassName("taca_app").length === 1 ? "This Lender Credit is an exclusive offer to the members of TACA that register through this site. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non-transferable and cannot be combined with any other offer." : "This Lender Credit is an exclusive offer to the clients on transactions wherein Sun West Mortgage Company, Inc. is the lender. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non-transferable, subject to change or cancellation without notice except as required by law and cannot be combined with any other offer.") : null) : null) : null), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showRefinanceRates ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex justify-content-center"
  }, themeLeadSource !== "BL617RAN003" && themeLeadSource !== "NET021" ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: "10",
    md: "8",
    className: "pt-2 mt-2 ratesTitle text-center mainBody",
    style: {
      color: "rgb(14, 62, 155)"
    }
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: showRefinanceCvnRates ? "mb-0" : " d-none"
  }, handleLoanPurpose(themeRefinanceLoanPurpose), " ", themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? "| No Subordinate Financing " : null, "| ", defaultCreditScore, " FICO"), showRefinanceCvnRates ? /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", refinanceConvLimit ? " Maximum loan amount may vary for your county." : null, /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, ".") : null, /*#__PURE__*/_react.default.createElement("h6", {
    className: showRefinanceFHARates && (refinanceFha15A.match === true || refinanceFha30A.match === true) ? "mb-0" : " d-none"
  }, handleLoanPurpose(themeRefinanceLoanPurpose), " ", themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? "| No Subordinate Financing " : null, "| ", defaultCreditScore, " FICO"), showRefinanceFHARates && (refinanceFha15A.match === true || refinanceFha30A.match === true) ? /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", refinanceFhaLimit ? " Maximum loan amount may vary for your county." : null, /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, ".") : null, /*#__PURE__*/_react.default.createElement("h6", {
    className: showRefinanceVARates && (refinanceVa15A.match === true || refinanceVa30A.match === true) ? "mb-0" : " d-none"
  }, handleLoanPurpose(themeRefinanceLoanPurpose), " ", themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? "| No Subordinate Financing " : null, "| ", defaultCreditScore, " FICO"), showRefinanceVARates && (refinanceVa15A.match === true || refinanceVa30A.match === true) ? /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", refinanceVaLimit ? " Maximum loan amount may vary for your county." : null, /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, ".") : null, /*#__PURE__*/_react.default.createElement("h6", {
    className: showRefinanceUsdaRates && (refinanceUsda15A.match === true || refinanceUsda30A.match === true) ? "mb-0" : " d-none"
  }, handleLoanPurpose(themeRefinanceLoanPurpose), " ", themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? "| No Subordinate Financing " : null, "| ", defaultCreditScore, " FICO"), showRefinanceUsdaRates && (refinanceUsda15A.match === true || refinanceUsda30A.match === true) ? /*#__PURE__*/_react.default.createElement("h6", null, "The rates above are based on a loan amount of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchLoanAmount,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), " ", "with an appraised value of", " ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: branchPropertyValue,
    displayType: "text",
    thousandSeparator: true,
    prefix: "$",
    decimalScale: 0,
    fixedDecimalScale: false
  }), ".", /*#__PURE__*/_react.default.createElement("br", null), "Loans that do not meet these criteria may have a higher interest rate and Annual Percentage Rate (APR).", " ", refinanceUsdaLimit ? " Maximum loan amount may vary for your county." : null, /*#__PURE__*/_react.default.createElement("br", null), "Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR are estimates as of\xA0", productCreationTime, ".") : null, themeLeadSource === "NET049" || themeLeadSource === "INBOUNDNONPC" ? /*#__PURE__*/_react.default.createElement("h6", null, document.getElementsByClassName("taca_app") && document.getElementsByClassName("taca_app").length === 1 ? "This Lender Credit is an exclusive offer to the members of TACA that register through this site. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non-transferable and cannot be combined with any other offer." : "This Lender Credit is an exclusive offer to the clients on transactions wherein Sun West Mortgage Company, Inc. is the lender. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non-transferable, subject to change or cancellation without notice except as required by law and cannot be combined with any other offer.") : null) : null) : null)) : null));
}
var _default = exports.default = Rates;